import script from "./displayAccordion.vue?vue&type=script&setup=true&lang=js"
export * from "./displayAccordion.vue?vue&type=script&setup=true&lang=js"

import "./displayAccordion.vue?vue&type=style&index=0&id=04b62fcc&lang=scss&scoped=true"

import exportComponent from "/home/steffen/Projekte/clubadmin/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04b62fcc"]])

export default __exports__